import { render, staticRenderFns } from "./resourceLedgerList.vue?vue&type=template&id=63ebb8d2&"
import script from "./resourceLedgerList.vue?vue&type=script&lang=js&"
export * from "./resourceLedgerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports